import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 2a11 11 0 100 22 11 11 0 000-22zm0 20.167a9.167 9.167 0 110-18.334 9.167 9.167 0 010 18.334z",
      fill: "#121215"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.116 14.951a.916.916 0 00-1.246.349A3.373 3.373 0 0112 17.133 3.372 3.372 0 019.132 15.3a.92.92 0 10-1.595.916 5.151 5.151 0 004.465 2.75 5.152 5.152 0 004.464-2.75.916.916 0 00-.349-1.265zM8.333 12.085a1.833 1.833 0 100-3.667 1.833 1.833 0 000 3.667zM15.665 12.085a1.833 1.833 0 100-3.667 1.833 1.833 0 000 3.667z",
      fill: "#121215"
    }
  )
);
export {
  a as default
};
